var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapesBackgroundMuerdete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1587,
    zoomAndPan: "magnify",
    viewBox: "0 0 1190.25 1417.499958",
    height: 1889,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "385cfdb6c2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.527344 164.117188 L 193.664062 164.117188 L 193.664062 188.257812 L 169.527344 188.257812 Z M 169.527344 164.117188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5cf48ad27d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 181.597656 188.257812 C 188.265625 188.257812 193.664062 182.855469 193.664062 176.1875 C 193.664062 169.519531 188.265625 164.117188 181.597656 164.117188 C 174.925781 164.117188 169.527344 169.519531 169.527344 176.1875 C 169.527344 182.855469 174.925781 188.257812 181.597656 188.257812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "56b004b0aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 122.816406 164.117188 L 146.953125 164.117188 L 146.953125 188.257812 L 122.816406 188.257812 Z M 122.816406 164.117188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "33622221f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 134.886719 188.257812 C 141.554688 188.257812 146.953125 182.855469 146.953125 176.1875 C 146.953125 169.519531 141.554688 164.117188 134.886719 164.117188 C 128.214844 164.117188 122.816406 169.519531 122.816406 176.1875 C 122.816406 182.855469 128.214844 188.257812 134.886719 188.257812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b682a76fde"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.902344 164.117188 L 104.042969 164.117188 L 104.042969 188.257812 L 79.902344 188.257812 Z M 79.902344 164.117188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "76e0e5a594"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91.972656 188.257812 C 98.640625 188.257812 104.042969 182.855469 104.042969 176.1875 C 104.042969 169.519531 98.640625 164.117188 91.972656 164.117188 C 85.304688 164.117188 79.902344 169.519531 79.902344 176.1875 C 79.902344 182.855469 85.304688 188.257812 91.972656 188.257812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "112f4bfe53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.992188 164.117188 L 61.128906 164.117188 L 61.128906 188.257812 L 36.992188 188.257812 Z M 36.992188 164.117188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f34fd3ac76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.058594 188.257812 C 55.730469 188.257812 61.128906 182.855469 61.128906 176.1875 C 61.128906 169.519531 55.730469 164.117188 49.058594 164.117188 C 42.390625 164.117188 36.992188 169.519531 36.992188 176.1875 C 36.992188 182.855469 42.390625 188.257812 49.058594 188.257812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "570737a8e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.527344 203.453125 L 193.664062 203.453125 L 193.664062 227.59375 L 169.527344 227.59375 Z M 169.527344 203.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "721f5fbd5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 181.597656 227.59375 C 188.265625 227.59375 193.664062 222.195312 193.664062 215.523438 C 193.664062 208.855469 188.265625 203.453125 181.597656 203.453125 C 174.925781 203.453125 169.527344 208.855469 169.527344 215.523438 C 169.527344 222.195312 174.925781 227.59375 181.597656 227.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7e54bbf43e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 122.816406 203.453125 L 146.953125 203.453125 L 146.953125 227.59375 L 122.816406 227.59375 Z M 122.816406 203.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f91819741e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 134.886719 227.59375 C 141.554688 227.59375 146.953125 222.195312 146.953125 215.523438 C 146.953125 208.855469 141.554688 203.453125 134.886719 203.453125 C 128.214844 203.453125 122.816406 208.855469 122.816406 215.523438 C 122.816406 222.195312 128.214844 227.59375 134.886719 227.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a4e53a9ea5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.902344 203.453125 L 104.042969 203.453125 L 104.042969 227.59375 L 79.902344 227.59375 Z M 79.902344 203.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "85ea7b9c38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91.972656 227.59375 C 98.640625 227.59375 104.042969 222.195312 104.042969 215.523438 C 104.042969 208.855469 98.640625 203.453125 91.972656 203.453125 C 85.304688 203.453125 79.902344 208.855469 79.902344 215.523438 C 79.902344 222.195312 85.304688 227.59375 91.972656 227.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d03e86cb27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.992188 203.453125 L 61.128906 203.453125 L 61.128906 227.59375 L 36.992188 227.59375 Z M 36.992188 203.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "552897a6d0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.058594 227.59375 C 55.730469 227.59375 61.128906 222.195312 61.128906 215.523438 C 61.128906 208.855469 55.730469 203.453125 49.058594 203.453125 C 42.390625 203.453125 36.992188 208.855469 36.992188 215.523438 C 36.992188 222.195312 42.390625 227.59375 49.058594 227.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "52462d2ff9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.527344 242.792969 L 193.664062 242.792969 L 193.664062 266.929688 L 169.527344 266.929688 Z M 169.527344 242.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7df46bf0b9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 181.597656 266.929688 C 188.265625 266.929688 193.664062 261.53125 193.664062 254.859375 C 193.664062 248.191406 188.265625 242.792969 181.597656 242.792969 C 174.925781 242.792969 169.527344 248.191406 169.527344 254.859375 C 169.527344 261.53125 174.925781 266.929688 181.597656 266.929688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e17268dbb7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 122.816406 242.792969 L 146.953125 242.792969 L 146.953125 266.929688 L 122.816406 266.929688 Z M 122.816406 242.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c4460eebb6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 134.886719 266.929688 C 141.554688 266.929688 146.953125 261.53125 146.953125 254.859375 C 146.953125 248.191406 141.554688 242.792969 134.886719 242.792969 C 128.214844 242.792969 122.816406 248.191406 122.816406 254.859375 C 122.816406 261.53125 128.214844 266.929688 134.886719 266.929688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "673323efc7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.902344 242.792969 L 104.042969 242.792969 L 104.042969 266.929688 L 79.902344 266.929688 Z M 79.902344 242.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bdab483b85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91.972656 266.929688 C 98.640625 266.929688 104.042969 261.53125 104.042969 254.859375 C 104.042969 248.191406 98.640625 242.792969 91.972656 242.792969 C 85.304688 242.792969 79.902344 248.191406 79.902344 254.859375 C 79.902344 261.53125 85.304688 266.929688 91.972656 266.929688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "543b73d637"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.992188 242.792969 L 61.128906 242.792969 L 61.128906 266.929688 L 36.992188 266.929688 Z M 36.992188 242.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1a28c7580b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.058594 266.929688 C 55.730469 266.929688 61.128906 261.53125 61.128906 254.859375 C 61.128906 248.191406 55.730469 242.792969 49.058594 242.792969 C 42.390625 242.792969 36.992188 248.191406 36.992188 254.859375 C 36.992188 261.53125 42.390625 266.929688 49.058594 266.929688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aac43f7dc4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.527344 282.128906 L 193.664062 282.128906 L 193.664062 306.265625 L 169.527344 306.265625 Z M 169.527344 282.128906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "343a3780ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 181.597656 306.265625 C 188.265625 306.265625 193.664062 300.867188 193.664062 294.195312 C 193.664062 287.527344 188.265625 282.128906 181.597656 282.128906 C 174.925781 282.128906 169.527344 287.527344 169.527344 294.195312 C 169.527344 300.867188 174.925781 306.265625 181.597656 306.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "768494caaa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 122.816406 282.128906 L 146.953125 282.128906 L 146.953125 306.265625 L 122.816406 306.265625 Z M 122.816406 282.128906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d9cdd6256c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 134.886719 306.265625 C 141.554688 306.265625 146.953125 300.867188 146.953125 294.195312 C 146.953125 287.527344 141.554688 282.128906 134.886719 282.128906 C 128.214844 282.128906 122.816406 287.527344 122.816406 294.195312 C 122.816406 300.867188 128.214844 306.265625 134.886719 306.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "432fca52fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.902344 282.128906 L 104.042969 282.128906 L 104.042969 306.265625 L 79.902344 306.265625 Z M 79.902344 282.128906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c67f59d82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91.972656 306.265625 C 98.640625 306.265625 104.042969 300.867188 104.042969 294.195312 C 104.042969 287.527344 98.640625 282.128906 91.972656 282.128906 C 85.304688 282.128906 79.902344 287.527344 79.902344 294.195312 C 79.902344 300.867188 85.304688 306.265625 91.972656 306.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4f933c3efb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.992188 282.128906 L 61.128906 282.128906 L 61.128906 306.265625 L 36.992188 306.265625 Z M 36.992188 282.128906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "073dce9737"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.058594 306.265625 C 55.730469 306.265625 61.128906 300.867188 61.128906 294.195312 C 61.128906 287.527344 55.730469 282.128906 49.058594 282.128906 C 42.390625 282.128906 36.992188 287.527344 36.992188 294.195312 C 36.992188 300.867188 42.390625 306.265625 49.058594 306.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "040954f76d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 122.816406 321.703125 L 146.953125 321.703125 L 146.953125 345.839844 L 122.816406 345.839844 Z M 122.816406 321.703125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1edf901f5a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 134.886719 345.839844 C 141.554688 345.839844 146.953125 340.441406 146.953125 333.773438 C 146.953125 327.101562 141.554688 321.703125 134.886719 321.703125 C 128.214844 321.703125 122.816406 327.101562 122.816406 333.773438 C 122.816406 340.441406 128.214844 345.839844 134.886719 345.839844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "512c6705ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.902344 321.703125 L 104.042969 321.703125 L 104.042969 345.839844 L 79.902344 345.839844 Z M 79.902344 321.703125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c1c0e1412e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91.972656 345.839844 C 98.640625 345.839844 104.042969 340.441406 104.042969 333.773438 C 104.042969 327.101562 98.640625 321.703125 91.972656 321.703125 C 85.304688 321.703125 79.902344 327.101562 79.902344 333.773438 C 79.902344 340.441406 85.304688 345.839844 91.972656 345.839844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "568f3b82be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.992188 321.703125 L 61.128906 321.703125 L 61.128906 345.839844 L 36.992188 345.839844 Z M 36.992188 321.703125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f1cef63e83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.058594 345.839844 C 55.730469 345.839844 61.128906 340.441406 61.128906 333.773438 C 61.128906 327.101562 55.730469 321.703125 49.058594 321.703125 C 42.390625 321.703125 36.992188 327.101562 36.992188 333.773438 C 36.992188 340.441406 42.390625 345.839844 49.058594 345.839844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "67b892fb07"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 122.816406 361.277344 L 146.953125 361.277344 L 146.953125 385.414062 L 122.816406 385.414062 Z M 122.816406 361.277344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "371ae9da8e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 134.886719 385.414062 C 141.554688 385.414062 146.953125 380.015625 146.953125 373.347656 C 146.953125 366.675781 141.554688 361.277344 134.886719 361.277344 C 128.214844 361.277344 122.816406 366.675781 122.816406 373.347656 C 122.816406 380.015625 128.214844 385.414062 134.886719 385.414062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a1ef64c7bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.902344 361.277344 L 104.042969 361.277344 L 104.042969 385.414062 L 79.902344 385.414062 Z M 79.902344 361.277344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "64e26c640c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91.972656 385.414062 C 98.640625 385.414062 104.042969 380.015625 104.042969 373.347656 C 104.042969 366.675781 98.640625 361.277344 91.972656 361.277344 C 85.304688 361.277344 79.902344 366.675781 79.902344 373.347656 C 79.902344 380.015625 85.304688 385.414062 91.972656 385.414062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "083be16d42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.992188 361.277344 L 61.128906 361.277344 L 61.128906 385.414062 L 36.992188 385.414062 Z M 36.992188 361.277344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "44361d44b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.058594 385.414062 C 55.730469 385.414062 61.128906 380.015625 61.128906 373.347656 C 61.128906 366.675781 55.730469 361.277344 49.058594 361.277344 C 42.390625 361.277344 36.992188 366.675781 36.992188 373.347656 C 36.992188 380.015625 42.390625 385.414062 49.058594 385.414062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6009f12b7b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 998.171875 478.335938 L 1185.632812 478.335938 L 1185.632812 665.796875 L 998.171875 665.796875 Z M 998.171875 478.335938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "963a47eab9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1091.902344 478.335938 C 1040.136719 478.335938 998.171875 520.300781 998.171875 572.066406 C 998.171875 623.832031 1040.136719 665.796875 1091.902344 665.796875 C 1143.667969 665.796875 1185.632812 623.832031 1185.632812 572.066406 C 1185.632812 520.300781 1143.667969 478.335938 1091.902344 478.335938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a95144200a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 133.933594 687.972656 L 206 687.972656 L 206 1017 L 133.933594 1017 Z M 133.933594 687.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7d2ec6917"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 147.535156 687.972656 L 138.265625 698.207031 L 187.878906 756.847656 L 133.933594 820.613281 L 187.878906 884.375 L 133.933594 948.140625 L 192.210938 1017.015625 L 201.480469 1006.785156 L 151.867188 948.140625 L 205.808594 884.375 L 151.867188 820.613281 L 205.808594 756.847656 Z M 147.535156 687.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "751dcfc49f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 246.148438 687.972656 L 318.914062 687.972656 L 318.914062 1017 L 246.148438 1017 Z M 246.148438 687.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0e25c50f7a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 259.75 687.972656 L 250.480469 698.207031 L 300.09375 756.847656 L 246.148438 820.613281 L 300.09375 884.375 L 246.148438 948.140625 L 304.425781 1017.015625 L 313.695312 1006.785156 L 264.078125 948.140625 L 318.023438 884.375 L 264.078125 820.613281 L 318.023438 756.847656 Z M 259.75 687.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed6ffa7337"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 916.640625 1054.035156 L 1066.589844 1054.035156 L 1066.589844 1203.984375 L 916.640625 1203.984375 Z M 916.640625 1054.035156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "57dd78d5f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 991.613281 1054.035156 C 950.207031 1054.035156 916.640625 1087.601562 916.640625 1129.007812 C 916.640625 1170.417969 950.207031 1203.984375 991.613281 1203.984375 C 1033.019531 1203.984375 1066.589844 1170.417969 1066.589844 1129.007812 C 1066.589844 1087.601562 1033.019531 1054.035156 991.613281 1054.035156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c66a7c1f87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 916.640625 1054.035156 L 1066.609375 1054.035156 L 1066.609375 1204.003906 L 916.640625 1204.003906 Z M 916.640625 1054.035156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "976460460d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 991.625 1054.035156 C 950.210938 1054.035156 916.640625 1087.605469 916.640625 1129.019531 C 916.640625 1170.433594 950.210938 1204.003906 991.625 1204.003906 C 1033.035156 1204.003906 1066.609375 1170.433594 1066.609375 1129.019531 C 1066.609375 1087.605469 1033.035156 1054.035156 991.625 1054.035156 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#385cfdb6c2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5cf48ad27d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 193.664062 164.117188 L 193.664062 188.257812 L 169.527344 188.257812 L 169.527344 164.117188 Z M 193.664062 164.117188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#56b004b0aa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33622221f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 146.953125 164.117188 L 146.953125 188.257812 L 122.816406 188.257812 L 122.816406 164.117188 Z M 146.953125 164.117188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b682a76fde)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#76e0e5a594)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 104.042969 164.117188 L 104.042969 188.257812 L 79.902344 188.257812 L 79.902344 164.117188 Z M 104.042969 164.117188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#112f4bfe53)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f34fd3ac76)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 61.128906 164.117188 L 61.128906 188.257812 L 36.992188 188.257812 L 36.992188 164.117188 Z M 61.128906 164.117188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#570737a8e3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#721f5fbd5c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 193.664062 203.453125 L 193.664062 227.59375 L 169.527344 227.59375 L 169.527344 203.453125 Z M 193.664062 203.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7e54bbf43e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f91819741e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 146.953125 203.453125 L 146.953125 227.59375 L 122.816406 227.59375 L 122.816406 203.453125 Z M 146.953125 203.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a4e53a9ea5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#85ea7b9c38)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 104.042969 203.453125 L 104.042969 227.59375 L 79.902344 227.59375 L 79.902344 203.453125 Z M 104.042969 203.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d03e86cb27)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#552897a6d0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 61.128906 203.453125 L 61.128906 227.59375 L 36.992188 227.59375 L 36.992188 203.453125 Z M 61.128906 203.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#52462d2ff9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7df46bf0b9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 193.664062 242.792969 L 193.664062 266.929688 L 169.527344 266.929688 L 169.527344 242.792969 Z M 193.664062 242.792969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e17268dbb7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c4460eebb6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 146.953125 242.792969 L 146.953125 266.929688 L 122.816406 266.929688 L 122.816406 242.792969 Z M 146.953125 242.792969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#673323efc7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bdab483b85)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 104.042969 242.792969 L 104.042969 266.929688 L 79.902344 266.929688 L 79.902344 242.792969 Z M 104.042969 242.792969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#543b73d637)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1a28c7580b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 61.128906 242.792969 L 61.128906 266.929688 L 36.992188 266.929688 L 36.992188 242.792969 Z M 61.128906 242.792969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aac43f7dc4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#343a3780ae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 193.664062 282.128906 L 193.664062 306.265625 L 169.527344 306.265625 L 169.527344 282.128906 Z M 193.664062 282.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#768494caaa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d9cdd6256c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 146.953125 282.128906 L 146.953125 306.265625 L 122.816406 306.265625 L 122.816406 282.128906 Z M 146.953125 282.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#432fca52fe)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c67f59d82)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 104.042969 282.128906 L 104.042969 306.265625 L 79.902344 306.265625 L 79.902344 282.128906 Z M 104.042969 282.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4f933c3efb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#073dce9737)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 61.128906 282.128906 L 61.128906 306.265625 L 36.992188 306.265625 L 36.992188 282.128906 Z M 61.128906 282.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#040954f76d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1edf901f5a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 146.953125 321.703125 L 146.953125 345.839844 L 122.816406 345.839844 L 122.816406 321.703125 Z M 146.953125 321.703125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#512c6705ed)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c1c0e1412e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 104.042969 321.703125 L 104.042969 345.839844 L 79.902344 345.839844 L 79.902344 321.703125 Z M 104.042969 321.703125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#568f3b82be)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f1cef63e83)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 61.128906 321.703125 L 61.128906 345.839844 L 36.992188 345.839844 L 36.992188 321.703125 Z M 61.128906 321.703125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#67b892fb07)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#371ae9da8e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 146.953125 361.277344 L 146.953125 385.414062 L 122.816406 385.414062 L 122.816406 361.277344 Z M 146.953125 361.277344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a1ef64c7bd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#64e26c640c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 104.042969 361.277344 L 104.042969 385.414062 L 79.902344 385.414062 L 79.902344 361.277344 Z M 104.042969 361.277344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#083be16d42)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#44361d44b5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 61.128906 361.277344 L 61.128906 385.414062 L 36.992188 385.414062 L 36.992188 361.277344 Z M 61.128906 361.277344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6009f12b7b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#963a47eab9)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.749936, 0, 0, 0.749936, 998.171887, 478.334668)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 124.984669 0.00169242 C 55.957912 0.00169242 -0.0000154558 55.95962 -0.0000154558 124.986377 C -0.0000154558 194.013134 55.957912 249.971061 124.984669 249.971061 C 194.011426 249.971061 249.969353 194.013134 249.969353 124.986377 C 249.969353 55.95962 194.011426 0.00169242 124.984669 0.00169242 ",
    stroke: "#7bdec1",
    strokeWidth: 20,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a95144200a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7d2ec6917)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8d04f",
    d: "M 133.933594 687.972656 L 205.800781 687.972656 L 205.800781 1016.765625 L 133.933594 1016.765625 Z M 133.933594 687.972656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#751dcfc49f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0e25c50f7a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8d04f",
    d: "M 246.148438 687.972656 L 318.015625 687.972656 L 318.015625 1016.765625 L 246.148438 1016.765625 Z M 246.148438 687.972656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed6ffa7337)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#57dd78d5f4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4b1b0",
    d: "M 916.640625 1054.035156 L 1066.589844 1054.035156 L 1066.589844 1203.984375 L 916.640625 1203.984375 Z M 916.640625 1054.035156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c66a7c1f87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#976460460d)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.749959, 0, 0, 0.749959, 916.640089, 1054.035172)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 99.985338 -0.0000210708 C 44.763575 -0.0000210708 0.000714994 44.762839 0.000714994 99.984602 C 0.000714994 155.206366 44.763575 199.969226 99.985338 199.969226 C 155.201893 199.969226 199.969962 155.206366 199.969962 99.984602 C 199.969962 44.762839 155.201893 -0.0000210708 99.985338 -0.0000210708 ",
    stroke: "#f4b1b0",
    strokeWidth: 20,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapesBackgroundMuerdete);
export default __webpack_public_path__ + "static/media/shapes_background_muerdete.b8892a64c08f665cc6b0321fe5f9ea8b.svg";
export { ForwardRef as ReactComponent };